import {
  AutonomousTaskStopped,
  BatteryDeepDischarge,
  CleaningTaskFinished,
  EmergencyStop,
  ErrorOccured,
  LocationStatus,
  Notification,
  Resources,
  ServiceNeeded
} from 'assets/images';
import { SUBSCRIPTION_MESSAGE_TYPE } from 'util/config/constant';

export const MAPPING_NOTIFICATION_ICON_BY_NOTIFICATION_TYPE = {
  RESOURCES: Resources,
  ERROR_OCCURRED: ErrorOccured,
  BATTERY_DEEP_DISCHARGE: BatteryDeepDischarge,
  AUTONOMOUS_TASK_STOPPED: AutonomousTaskStopped,
  SERVICE_NEEDED: ServiceNeeded,
  LOCATION_STATUS: LocationStatus,
  CLEANING_TASK_FINISHED: CleaningTaskFinished,
  EMERGENCY_STOP: EmergencyStop,
  UNDEFINED: Notification
};

export const MAPPING_ICON_CLASSNAME_BY_NOTIFICATION_SEVERITY = {
  INFORMATIVE: 'informativeSeverityColor',
  NEED_FOR_ACTION: 'nfaColor',
  ALERT: 'alertColor'
};

export const MAPPING_ROUTE_BY_MESSAGE_TYPE = {
  [SUBSCRIPTION_MESSAGE_TYPE.CLEANING_REPORT]: '/cleaning-report',
  [SUBSCRIPTION_MESSAGE_TYPE.NOTIFICATION]: '/notifications'
};
